// Custom hooks logic based on https://tkdodo.eu/blog/working-with-zustand

import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

type State = {
  additionalInfo: string
}

type Actions = {
  setAdditionalInfo: (info: string) => void
  reset: () => void
}

type AdditionalInfoStore = State & Actions

const initialState: State = {
  additionalInfo: '',
}

const useAdditionalInfoStore = create<AdditionalInfoStore>()(
  devtools(
    persist(
      (set) => ({
        ...initialState,
        setAdditionalInfo: (info: string) => {
          set({ additionalInfo: info })
        },
        reset: () => {
          set(initialState)
        },
      }),
      {
        name: 'additional-info-storage',
      }
    ),
    {
      name: 'additional-info-store',
    }
  )
)

// Selectors
export const useAdditionalInfo = () => useAdditionalInfoStore((state) => state.additionalInfo)

// Actions
export const useAdditionalInfoActions = () =>
  useAdditionalInfoStore((state) => ({
    setAdditionalInfo: state.setAdditionalInfo,
    reset: state.reset,
  }))
